import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium", _ctx.statusStyle])
  }, _toDisplayString(_ctx.statusText), 3))
}